module.exports = __webpack_public_path__ + "static/media/home_japan_main5.b4779836.svg";